module.exports = __webpack_public_path__ + "img/759-8b2190.png";